export default __webpack_public_path__ + "media/carousel/paper-8f8363e6.png";